import { QueovalBase, QueovalDate, QueovalDik, QueovalItem } from '../global';
import { Person, Corporation } from './action-co.model';
import { Select } from '../utilities/utilities.model';



export class ActionCoPipeModel extends QueovalBase {
  SelectedColumnPipe: PipeColumn;
  PipeColumns: Array<PipeColumn>;
  CardImage: Array<QueovalDik>;
  UpdateCardPosition: QueovalDik;
  ListCollaborateur: Array<Person>;
  PipeSearch: Array<QueovalItem>;
  public lstModes: Array<Select>;
  public ListPriorites: Array<Select>;
  Filter: string;
  Order: string;
  Client: Select;
  ClientData: Corporation;
  TypeColumnFilter: string;
  constructor() {
    super();
    this.SelectedColumnPipe = new PipeColumn();
    this.PipeColumns = new Array<PipeColumn>();
    this.CardImage = new Array<QueovalDik>();
    this.ListCollaborateur = new Array<Person>();
    this.PipeSearch = new Array<QueovalItem>();
    this.lstModes = new Array<Select>();
    this.ListPriorites = new Array<Select>();
    this.Client = new Select();
  }
}

export class PipeColumn {
  Title: string;
  Type: string;
  Price: number;
  PricePonderation: number;
  UnfilteredPrice: number;
  UnfilteredPricePonderation: number;
  IsModeEdit: boolean;
  Cards: Array<PipeCard>

  constructor() {
    this.IsModeEdit = false;
    this.Cards = new Array<PipeCard>();
  }
}

export class PipeCard {
  Ident: string;
  ClientId: string;
  Client: string;
  Title: string;
  Info: string;
  Categorie: string;
  Date: QueovalDate;
  Price: number;
  PricePonderation: number;
  Ponderation: number;
  Document: number;
  Priorite: string;

  ContactId: string;
  Contact: string;
  ContactInfo: Person;

  CollaboName: string;
  CollaboId: string;
  CollaboAvatarUrl: string;

  HistoLastUpdate: QueovalDate;
  HistoNb: number;
  HistoNumberOfDaysInfo: string;
  HistoNumberOfDays: number;
  HistoLastInfo: string;

  DateBadgeColor: string;
  DateAbbreviation: string;

  StatusBadgeColor: string;
  Status: string;

  IsCloture: boolean;
  //Front variable
  IsDragging: boolean;
  Filtered: boolean;
}


export class PipeActionCoFilterOption {
  OrderValue: string;
  CollaborateurValue: Array<Person>;
  CntClientValue: QueovalItem;
  IsPonderation: boolean;
  IsCloture: boolean;
  listCollaborateurs: Array<Person>;
  filterPriorite: string;
  filterByTags: any;
  constructor() {
    
    this.OrderValue = 'ACOASC';
    this.CollaborateurValue = new Array<Person>();
    this.CntClientValue = new QueovalItem();
    this.IsPonderation = false;
    this.IsCloture=false;
    this.listCollaborateurs = new Array<Person>();
    this.filterPriorite='';
    this.filterByTags='';
  }
}
